import React from 'react';
import PageHero from '../common/PageHero';
import { useTranslation } from 'react-i18next';

const PartnersHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageHero
      eyebrow={t('partnersSection.hero.eyebrow')}
      title={t('partnersSection.hero.title')}
      description={t('partnersSection.hero.description')}
      typedTitle
    />
  );
};

export default PartnersHero;
